import { useCallback, useMemo } from "react";
import { clinicianPortalApi } from "../api/clinicianPortalApi";
import { usePortalData } from "./usePortalData";

export function useActivityTemplateTypeLookup(
  clinicianCode: string,
): ReadonlyMap<string, string> {
  const request = useCallback(
    (signal: AbortSignal) =>
      clinicianPortalApi.getActivityTemplates(clinicianCode, signal),
    [clinicianCode],
  );
  const state = usePortalData(request, { enabled: Boolean(clinicianCode) });
  const data =
    state.status === "success" || state.status === "refreshing"
      ? state.data
      : undefined;

  return useMemo(
    () =>
      new Map<string, string>(
        data?.authorized && data.found
          ? data.templates.map(
              (template) => [template.id, template.activityType] as const,
            )
          : [],
      ),
    [data],
  );
}
